import { useContext, useState } from "react";
import { Button, Grid, IconButton, Typography } from "@material-ui/core";
import { AuthContext } from "context/context";
import endoso from "services/endoso";
import { HighRiskForm, UploadExcel } from "../";
import useStyles from "./styles";
import { AltaContext } from "pages/endoso/context";
import { TitularesTable } from "../highVolunteerForm";
import { GroupAddRounded } from "@material-ui/icons";
import { ModalForm } from "../../../altaRiesgo16/components";

export const SectionSelector = ({ setMessage, setShowMessage }) => {
  const classes = useStyles();
  const { setTimer } = useContext(AuthContext);
  const { initialData, openModal } = useContext(AltaContext);
  const [selected, setSelected] = useState();
  const [disabled, setDisabled] = useState(false);

  const activate = () => setDisabled(false);
  const download = () => {
    setTimer(0);
    setDisabled(true);
    endoso.descargarLayout(activate, initialData.formaAseguramiento);
  };

  const returntoMain = () => setSelected(undefined);
  if (selected === "tradicional")
    return (
      <HighRiskForm
        setMessage={setMessage}
        setShowMessage={setShowMessage}
        idSolicitud={12345}
      />
    );
  else if (selected === "voluntario")
    return (
      <div className={classes.root}>
        <TitularesTable />

        <IconButton
          variant="contained"
          className={classes.buttonModal}
          size="small"
          onClick={() => openModal(undefined)}
        >
          <GroupAddRounded />
        </IconButton>

        <ModalForm />
      </div>
    );

  if (selected === "archivo")
    return <UploadExcel returntoMain={returntoMain} />;
  return (
    <div>
      <Typography variant="h6">
        ¿Cómo desea agregar los nuevos asegurados?
      </Typography>
      <Grid container spacing={2} className={classes.container}>
        <Grid item>
          <Button
            variant="contained"
            color="primary"
            className={classes.button}
            onClick={() =>
              setSelected(
                initialData?.formaAseguramiento === "002"
                  ? "voluntario"
                  : "tradicional"
              )
            }
          >
            Agregar de manera tradicional
          </Button>
        </Grid>
        <Grid item>
          <Button
            variant="contained"
            color="primary"
            className={classes.button}
            onClick={() => setSelected("archivo")}
          >
            Agregar por archivo de asegurados
          </Button>
        </Grid>
        <Grid item>
          <Button
            variant="contained"
            color="primary"
            className={classes.button}
            onClick={download}
            disabled={disabled}
          >
            Descargar Plantilla de Layout
          </Button>
        </Grid>
      </Grid>
    </div>
  );
};
